import React from 'react';

export default function VadoLogo() {
    return <img style={{ height: '50px', width: 'auto' }} src="/Vado_logo_dark_blue.png" alt="VADO Logo" />;
}
